import { computed } from 'vue';
import { tagging as taggingProps } from './prop-definitions';

export default function createProvider(name, modeProps) {
  return {
    name,
    provide() {
      const providedProps = Object.keys({
        ...modeProps,
        ...taggingProps,
      }).reduce((acc, curr) => {
        acc[curr] = computed(() => {
          return this[curr];
        });
        return acc;
      }, {});
      return {
        ...providedProps,
        providerId: this.instanceId,
      };
    },
    props: {
      ...modeProps,
      ...taggingProps,
    },
    data() {
      return {
        instanceId: `ra-${Math.random().toString(36).slice(2, 11)}`,
      };
    },
  };
}
